@media (max-width: 480px) {
  .header-nav {
    flex-wrap: wrap;
  }
  .profile-info {
    flex-wrap: wrap;
    min-width: 0;
  }
  .profile-details {
    min-width: 0;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .profile-name, .profile-role {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    max-width: 70px;
  }
}
<template>
  <header class="header-nav">
    <!-- Botón de menú para móvil -->
    <button class="mobile-menu-btn" @click="toggleSidebar">
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </button>
    
    <div class="logo" @click="goHome" style="cursor: pointer;">
      <img src="/images/EDUTRACK.png" alt="EduTrack" style="height: 40px; width: auto;" />
    </div>
    <div class="profile-menu" @click="toggleDropdown($event)" ref="profileMenu">
      <div class="profile-info">
        <div class="profile-avatar">
          <span class="avatar-initials">{{ getInitials() }}</span>
        </div>
        <div class="profile-details">
          <span class="profile-name">{{ nombre }}</span>
          <span class="profile-role">{{ rol }}</span>
        </div>
        <div class="dropdown-arrow" :class="{ 'open': showDropdown }">
          <i class="arrow-down">▼</i>
        </div>
      </div>
      
      <!-- Dropdown Menu -->
      <div class="profile-dropdown" v-show="showDropdown">
        <div class="dropdown-header">
          <div class="dropdown-avatar">
            <span class="avatar-initials large">{{ getInitials() }}</span>
          </div>
          <div class="dropdown-details">
            <h4>{{ nombre }}</h4>
            <p>{{ rol }}</p>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <div class="dropdown-options">
          <!-- <div class="dropdown-item" @click="viewProfile">
            <span class="item-icon">👤</span>
            <span>Mi Perfil</span>
          </div> -->
          <!-- <div class="dropdown-item" @click="settings">
            <span class="item-icon">⚙️</span>
            <span>Configuración</span>
          </div> -->
          <div class="dropdown-divider"></div>
          <div class="dropdown-item logout-item" @click="logout">
            <span class="item-icon">🚪</span>
            <span>Cerrar Sesión</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      nombre: localStorage.getItem('nombre') || '',
      rol: localStorage.getItem('rol') || '',
      showDropdown: false,
      handleClickOutside: null
    };
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    logout() {
      localStorage.clear();
      this.$router.push('/login');
      window.location.reload();
    },
    toggleDropdown(event) {
      // Prevenir propagación del evento para evitar que dispare el click outside
      if (event) {
        event.stopPropagation();
      }
      this.showDropdown = !this.showDropdown;
    },
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    getInitials() {
      const names = this.nombre.split(' ');
      const initials = names.map(name => name.charAt(0)).slice(0, 2).join('');
      return initials.toUpperCase();
    },
    viewProfile() {
      this.showDropdown = false;
      // Aquí puedes agregar la lógica para ver el perfil
      console.log('Ver perfil');
    },
    settings() {
      this.showDropdown = false;
      // Aquí puedes agregar la lógica para configuración
      console.log('Configuración');
    }
  },
  mounted() {
    // Cerrar dropdown al hacer click fuera - con verificación robusta
    this.handleClickOutside = (event) => {
      try {
        // Verificar que el componente existe y está montado
        if (this.$refs && this.$refs.profileMenu && event.target) {
          const profileMenu = this.$refs.profileMenu;
          // Verificar que el elemento DOM existe y tiene el método contains
          if (profileMenu && typeof profileMenu.contains === 'function') {
            if (!profileMenu.contains(event.target)) {
              this.showDropdown = false;
            }
          }
        }
      } catch (error) {
        // En caso de cualquier error, simplemente cerrar el dropdown
        console.warn('Error en handleClickOutside:', error);
        this.showDropdown = false;
      }
    };
    
    // Agregar event listener solo si document existe
    if (typeof document !== 'undefined') {
      document.addEventListener('click', this.handleClickOutside);
    }
  },
  beforeUnmount() {
    // Limpiar event listener de forma segura
    try {
      if (this.handleClickOutside && typeof document !== 'undefined') {
        document.removeEventListener('click', this.handleClickOutside);
      }
    } catch (error) {
      console.warn('Error al limpiar event listener:', error);
    }
    this.handleClickOutside = null;
  }
};
</script>

<style>
.header-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #0a2860;
  color: #fff;
  padding: 1rem 2rem;
  height: 64px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  z-index: 1000 !important;
  box-sizing: border-box;
  width: 100%;
}

/* Botón de menú hamburguesa */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  gap: 4px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.mobile-menu-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.hamburger-line {
  width: 24px;
  height: 3px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* RESPONSIVO COMPLETO HEADER */

/* Tablets grandes */
@media (max-width: 1024px) {
  .header-nav {
    padding: 0.7rem 1rem !important;
    height: 58px !important;
  }
  .logo img {
    height: 36px !important;
  }
  .profile-info {
    gap: 10px;
    padding: 6px 12px;
  }
  .profile-name {
    font-size: 13px;
  }
  .profile-role {
    font-size: 11px;
  }
}

/* Mostrar botón en móvil y tablets */
@media (max-width: 768px) {
  .mobile-menu-btn {
    display: flex;
  }
  .header-nav {
    padding: 0.6rem 0.7rem !important;
    height: 56px !important;
  }
  .logo img {
    height: 34px !important;
    max-width: 120px !important;
  }
  .profile-info {
    gap: 8px;
    padding: 5px 10px;
  }
  .profile-avatar {
    width: 30px;
    height: 30px;
  }
  .profile-name {
    font-size: 12px;
  }
  .profile-role {
    font-size: 10px;
  }
}

/* Móviles medianos */
@media (max-width: 640px) {
  .header-nav {
    padding: 0.5rem 0.5rem !important;
    height: 52px !important;
  }
  .logo img {
    height: 30px !important;
    max-width: 100px !important;
  }
  .profile-info {
    gap: 6px;
    padding: 4px 8px;
  }
  .profile-avatar {
    width: 26px;
    height: 26px;
  }
  .avatar-initials {
    font-size: 12px;
  }
}

/* Móviles pequeños */
@media (max-width: 480px) {
  .header-nav {
    padding: 0.4rem 0.3rem !important;
    height: 48px !important;
  }
  .logo img {
    height: 26px !important;
    max-width: 85px !important;
  }
  .profile-info {
    gap: 4px;
    padding: 3px 6px;
  }
  .profile-avatar {
    width: 24px;
    height: 24px;
  }
  .profile-name {
    font-size: 11px;
  }
  .profile-role {
    font-size: 9px;
  }
  .avatar-initials {
    font-size: 11px;
  }
}

/* Móviles ultra pequeños */
@media (max-width: 360px) {
  .header-nav {
    padding: 0.3rem 0.2rem !important;
    height: 44px !important;
  }
  .logo img {
    height: 22px !important;
    max-width: 70px !important;
  }
  .profile-info {
    gap: 3px;
    padding: 2px 4px;
  }
  .profile-avatar {
    width: 20px;
    height: 20px;
  }
  .profile-name {
    font-size: 10px;
  }
  .profile-role {
    font-size: 8px;
  }
  .avatar-initials {
    font-size: 10px;
  }
  .hamburger-line {
    width: 20px;
    height: 2px;
  }
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
}

.profile-menu {
  position: relative;
  cursor: pointer;
  user-select: none;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 25px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.profile-info:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.profile-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.avatar-initials {
  color: white;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.avatar-initials.large {
  font-size: 18px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.profile-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 2px;
}

.profile-role {
  font-size: 12px;
  opacity: 0.8;
  font-weight: 400;
}

.dropdown-arrow {
  transition: transform 0.3s ease;
  margin-left: 8px;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.arrow-down {
  font-size: 10px;
  opacity: 0.7;
}

/* Dropdown Styles */
.profile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 280px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
  animation: dropdownFadeIn 0.3s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-header {
  padding: 20px;
  background: linear-gradient(135deg, #3854cf 0%, #3854cf  100%);
  color: white;
  display: flex;
  align-items: center;
  gap: 15px;
}

.dropdown-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.dropdown-details h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.dropdown-details p {
  margin: 2px 0 0 0;
  font-size: 13px;
  opacity: 0.9;
  font-weight: 400;
}

.dropdown-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 0;
}

.dropdown-options {
  padding: 8px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
}

.dropdown-item:hover {
  background: #f3f4f6;
  color: #1f2937;
}

.dropdown-item.logout-item {
  color: #dc2626;
}

.dropdown-item.logout-item:hover {
  background: #fef2f2;
  color: #991b1b;
}

.item-icon {
  font-size: 16px;
  width: 20px;
  text-align: center;
}
</style>
